import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'core_collections-product_based_collection_page_product_tile_gird-view';
/**
 * fire event when a product layout grid viewed by retailers on collection details page
 */
export function trackCoreCollectionsProductBasedCollectionPageProductTileGirdView(productBasedCollectionToken, productToken, Request_Id_string) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            productBasedCollectionToken,
            productToken,
            Request_Id_string,
        },
    });
}
